// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__21I4H","checkbox__label":"styles_checkbox__label__3133H"};